import {
	Vector3,
	Box3,
	Color,
	SphereGeometry,
	Mesh,
} from 'three';

import {colorTemperature2rgb} from './color-temperature';

export function degToRad(angle) {
	return angle * (Math.PI / 180);
}

export function radToDeg(angle) {
	return angle * (180 / Math.PI);
}

export function getLightColorFromTemperature(colorTemperature, fallbackValue) {
	// it could be null
	if (!colorTemperature) {
		colorTemperature = fallbackValue;
	}
	const matches = colorTemperature.match(/[0-9]+/);
	let value;
	if (matches) {
		value = +matches[0];
	} else {
		value = +fallbackValue.substring(0, fallbackValue.length - 1);
	}
	const rgb = colorTemperature2rgb(value);
	const color = new Color();
	color.setRGB(rgb.red / 255, rgb.green / 255, rgb.blue / 255);
	return color;
}

export function getLightPower(lumen, fallbackValue) {
	if (lumen !== null) {
		const matches = lumen.match(/[0-9]+/);
		if (matches) {
			return +matches[0];
		}
	}
	return fallbackValue;
}

let serviceShape = null;

export function getQuaternionByAngle(x, y, z) {
	if (!serviceShape) {
		const g = new SphereGeometry(1, 1, 1);
		serviceShape = new Mesh(g);
	}
	serviceShape.rotation.set(0, 0, 0);
	if (x !== 0) {
		serviceShape.rotateX(x);
	}
	if (y !== 0) {
		serviceShape.rotateY(y);
	}
	if (z !== 0) {
		serviceShape.rotateZ(z);
	}
	return serviceShape.quaternion.clone();
}

export function colorStringToInt(colorStr) {
	let hexString = colorStr.startsWith('#') ? colorStr.slice(1) : colorStr;
	if (hexString.length === 3) {
		hexString = hexString.split('').map(char => char + char).join('');
	}
	return parseInt(hexString, 16);
}

export function getColorSimpleBrightness(colorStr) {
	const intColor = colorStringToInt(colorStr);
	// https://alienryderflex.com/hsp.html
	const r = (intColor >> 16);
	const g = ((intColor >> 8) & 255);
	const b = (intColor & 255);
	return Math.sqrt(0.299 * (r / 255)**2 + 0.587 * (g / 255)**2 + 0.114 * (b / 255)**2);
}

// recursively find object by property name
export function getThreeObjectByName(object, name) {
	if (object.name === name) {
		return object;
	}
	for (const child of object.children) {
		const foundObject = getThreeObjectByName(child, name);
		if (foundObject) {
			return foundObject;
		}
	}
	return null;
}

export function getObjectSize(obj) {
	const box = new Box3();

	// ensure the bounding box is computed for its geometry
	// this should be done only once (assuming static geometries)
	obj.geometry.computeBoundingBox();

	box.copy(obj.geometry.boundingBox).applyMatrix4(obj.matrixWorld);
	const size = new Vector3();
	box.getSize(size);
	return size;
}

export function isString(value) {
	return typeof value === 'string' || Object.prototype.toString.call(value) === '[object String]';
}
